export const AdminUserStatus = {
	Active: 1,
	Inactive: 2
};

export const AdminUserStatusName = {
	[AdminUserStatus.Active]: 'Active',
	[AdminUserStatus.Inactive]: 'Inactive'
};
